import { createBrowserRouter, redirect } from 'react-router';

import { WelcomeRoute } from './routes/welcome-route.js';

function WorldRouteHydrateFallback(): React.JSX.Element {
  return (
    <main className="grid min-h-screen place-items-center bg-[oklch(16%_0.012_155)] p-6 text-[oklch(94%_0.01_85)]">
      <p
        className="rounded-lg border border-[oklch(31%_0.02_155)] bg-[oklch(20%_0.015_155)] px-5 py-4 text-sm text-[oklch(77%_0.018_145)]"
        role="status"
      >
        Loading shared room…
      </p>
    </main>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: WelcomeRoute,
  },
  {
    path: '/r/:slug',
    loader: ({ params, request }) => {
      const url = new URL(request.url);
      if (url.searchParams.has('t')) return null;
      const slug = params.slug ?? '';
      return redirect(`/?visibility=private&room=${encodeURIComponent(slug)}`);
    },
    HydrateFallback: WorldRouteHydrateFallback,
    lazy: async () => {
      const { WorldRoute } = await import('./routes/world-route.js');
      return { Component: WorldRoute };
    },
  },
]);
